import { lang as sv } from "assets/lang/sv/lang";
import { lang as en } from "assets/lang/en/lang";

type LanguageStringGroup = { [code: string]: string | string[] };
type Language = { [group: string]: LanguageStringGroup };

const LANGUAGE_STORAGE_KEY = "addyou_language";

const languages: { [key: string]: Language } = {
  sv: sv,
  en: en,
};

let currentLanguage: string = "sv"; // Default language

// Initialize language from local storage
const initializeLanguage = () => {
  try {
    const storedLang = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (storedLang && languages[storedLang]) {
      currentLanguage = storedLang;
    }
  } catch (error) {
    console.error("Error reading language from local storage:", error);
  }
};

// Initialize on module load
initializeLanguage();

const getLanguage = (): Language => {
  return languages[currentLanguage] || languages["sv"];
};

const get = (group_name: string, code: string) => {
  const language = getLanguage();
  const group = group_name ? language[group_name] : language;

  if (typeof group === "undefined")
    return "[" + (group_name ? group_name + "." : "") + code + "]";

  const lang = group[code];

  if (typeof lang === "undefined")
    return "[" + (group_name ? group_name + "." : "") + code + "]";

  return lang;
};

// Accepts optional globalAppMode to override translations for Health
export const getLanguageString = (
  group_name: string,
  code: string,
  globalAppMode?: "HEALTH" | "HR",
) => {
  // Default translation
  const lang_string = get(group_name, code);
  if (Array.isArray(lang_string))
    return "[" + (group_name ? group_name + "." : "") + code + "-IS-ARRAY]";
  return String(lang_string);
};

export const getLanguageStringArray = (
  group_name: string,
  code: string,
): string[] => {
  const lang_array = get(group_name, code);
  if (!Array.isArray(lang_array))
    return ["[" + (group_name ? group_name + "." : "") + code + "-NOT-ARRAY]"];

  return lang_array;
};

export const setLanguage = (lang: string) => {
  if (languages[lang]) {
    currentLanguage = lang;
    try {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, lang);
    } catch (error) {
      console.error("Error saving language to local storage:", error);
    }
  }
};

export const getCurrentLanguage = (): string => {
  return currentLanguage;
};

export const getAvailableLanguages = (): string[] => {
  return Object.keys(languages);
};
